import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tbody", "search", "header"]

  connect() {
    this.sortCol = null
    this.sortDir = "asc"
  }

  sort(event) {
    const col = parseInt(event.currentTarget.dataset.sortCol)

    if (this.sortCol === col) {
      this.sortDir = this.sortDir === "asc" ? "desc" : "asc"
    } else {
      this.sortCol = col
      this.sortDir = "asc"
    }

    this.updateSortIndicators()
    this.sortRows()
  }

  search() {
    const query = this.hasSearchTarget ? this.searchTarget.value.toLowerCase().trim() : ""
    const rows = this.tbodyTarget.querySelectorAll("tr")

    rows.forEach(row => {
      const match = query === "" || row.textContent.toLowerCase().includes(query)
      row.classList.toggle("hidden", !match)
    })
  }

  sortRows() {
    const tbody = this.tbodyTarget
    const rows = Array.from(tbody.querySelectorAll("tr"))

    rows.sort((a, b) => {
      const aVal = this.getCellValue(a, this.sortCol)
      const bVal = this.getCellValue(b, this.sortCol)
      const cmp = aVal.localeCompare(bVal, undefined, { numeric: true, sensitivity: "base" })
      return this.sortDir === "asc" ? cmp : -cmp
    })

    rows.forEach(row => tbody.appendChild(row))
  }

  getCellValue(row, colIndex) {
    const cells = row.querySelectorAll("td[data-sort-value]")
    return cells[colIndex]?.dataset.sortValue ?? ""
  }

  updateSortIndicators() {
    if (!this.hasHeaderTarget) return

    this.headerTargets.forEach(th => {
      const col = parseInt(th.dataset.sortCol)
      const indicator = th.querySelector("[data-sort-indicator]")
      if (!indicator) return
      indicator.textContent = col === this.sortCol ? (this.sortDir === "asc" ? "↑" : "↓") : ""
    })
  }
}
